import React from 'react';

import SvgIcon from '../../UI/SvgIcon/SvgIcon';
import Aux from '../../../containers/hoc/Auxiliary';

import facebookIcon from '../../../icons/facebook-empty.svg';
import instagramIcon from '../../../icons/instagram-thin.svg';
import etsyIcon from '../../../icons/etsy-sketch.svg';
import databaseIcon from '../../../icons/folder-with-eyeglass.svg';

const socialMediaField = () => (
    <Aux>
       
        <SvgIcon 
            url={"https://www.facebook.com/groups/DiverseMediumDesigns"} 
            icon={facebookIcon}
        />
    
        <SvgIcon 
            url={"https://www.instagram.com/diverse_medium/?hl=en"} 
            icon={instagramIcon}/>
        <SvgIcon 
            url={"https://www.etsy.com/shop/codaraho?fbclid=IwAR2dq7Boz_gEMUycEig-WC_8WVsLQ0v3eK0U5a2KBKrO6iXWg4SSWYCKhTE"} 
            icon={etsyIcon}/>
        <SvgIcon 
            url={"https://dmdpins.metalones.com/?fbclid=IwAR1tHhoL-Dx1Jkafzekwtz4RJSVzmcPhkIkC-QYFNBmQEUibPFsbaypNqao"} 
            icon={databaseIcon}/>        
    </Aux>
)

export default socialMediaField;


// WEBPACK FOOTER //
// ./src/components/UI/SocialMediaField/SocialMediaField.js